export default __webpack_public_path__ + "static/marx-lenin-stalin-5fa74ac8550ea02b5952c3c6f9ea25cf.avif";